module.exports = __webpack_public_path__ + "static/img/banner_6.a4f2d4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_6.jpg
// module id = o8LZ
// module chunks = 0